import './styles.scss';

import React from 'react';
import PropTypes from 'prop-types';

import PhotoSlider from 'Components/layout/PhotoSlider';
import Picture from 'Components/layout/Picture';

export default class SinglePhotoPhotoSectionPhoto extends React.Component {
    static propTypes = {
        photo: PropTypes.shape({
            imageUrl: PropTypes.string,
            selectedCaption: PropTypes.string,
        }).isRequired,
        galleryData: PropTypes.shape({
            isEnabled: PropTypes.bool.isRequired,
            nextPhotoId: PropTypes.string,
            prevPhotoId: PropTypes.string
        }).isRequired,
        onPrevPhoto: PropTypes.func,
        onNextPhoto: PropTypes.func,
        onClose: PropTypes.func,
    };
    static defaultProps = {}

    state = {
        loaded: false
    };

    componentWillMount() {
        this.setState(prevState => ({
            ...prevState,
            loaded: false
        }));
    }

    componentWillReceiveProps = nextProps => {
        this.setState(prevState => ({
            ...prevState,
            loaded: false
        }));
    }

    onPhotoLoad = () => {
        this.setState(prevState => ({
            ...prevState,
            loaded: true
        }));
    }

    render() {
        const { galleryData, photo } = this.props;

        return (
            <div className={`single-photo-photo-section-photo ${galleryData.isEnabled ? 'controls' : ''}`}>
                <PhotoSlider
                    isEnabled={galleryData.isEnabled}
                    onClose={this.props.onClose}
                    onPrevPhoto={this.props.onPrevPhoto}
                    onNextPhoto={this.props.onNextPhoto}
                    prevPhoto={galleryData.prevPhoto}
                    nextPhoto={galleryData.nextPhoto}
                    className={this.state.loaded ? 'loaded' : ''}
                >
                    <Picture
                        fullScreen={true}
                        url={photo.imageUrl}
                        alt={photo.selectedCaption}
                        onPhotoLoad={this.onPhotoLoad}
                        defaultResolution={960}
                        supportedResolutions={[
                            {
                                mediaQueryType: 'max',
                                screenWidth: 480,
                                photoWidth: 480
                            }, {
                                mediaQueryType: 'max',
                                screenWidth: 960,
                                photoWidth: 768
                            }, {
                                mediaQueryType: 'max',
                                screenWidth: 1199,
                                photoWidth: 960
                            }, {
                                mediaQueryType: 'min',
                                screenWidth: 1200,
                                photoWidth: 1200
                            }
                        ]}
                    />
                </PhotoSlider>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/public/single-photo/Photo/components/Photo/index.js